import { ListBox } from 'primereact/listbox';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { ToggleButton } from 'primereact/togglebutton';
import { Field, Form, useFormState } from 'react-final-form';
import { FloatLabel } from 'primereact/floatlabel';
import { classNames } from 'primereact/utils';
import OccupancyRate from './OccupancyRate';
import emoji from 'react-easy-emoji'
import countries from '../data/country.json'
const BuslineInput = ({ busLines, labels, isFormFieldValid, getFormErrorMessage }) => {
    const { values } = useFormState();
    return <Field name={"busLine"} render={
        ({ input, meta }) => {
            return (
                <div className="field">
                    <FloatLabel>
                        <Dropdown
                            scrollHeight="300px"
                            placeholder='Bus Line'
                            disabled={!values['takesBus']}
                            {...input}
                            optionLabel="name"
                            optionValue="name"
                            optionGroupLabel="reg_name"
                            optionGroupChildren={['lines']}
                            options={
                                Object.entries(busLines.reduce((acc, line) => {
                                    const key = line.country;
                                    if (!acc[key]) acc[key] = [];
                                    acc[key].push(line);
                                    return acc;
                                  }, {}))
                                    .map(entry => { return { 'reg_name': emoji(countries[entry[0]].emoji), 'lines': entry[1] }; })
                            }
                            className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                        />
                        <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                            {labels.busLine}
                        </label>
                    </FloatLabel>
                    {getFormErrorMessage(meta)}
                </div>
            )
        }} />
};
const BusStopPoint = ({labels, isFormFieldValid, getFormErrorMessage, getBusLineData, labelslanguage, label, inputname, tripType }) => {
    const { values } = useFormState();
    const lineisselected = values.takesBus && values.busLine;
    const enabled = (lineisselected && (values.tripType === tripType || values.tripType === 'roundtrip'));

    const busline = lineisselected ? getBusLineData(values.busLine) : {};
    const currentseats = parseFloat(busline.totalOneway) || 0;
    const maxseats = parseFloat(busline.maxSeats) || 0;
    return <Field name={inputname} render={
        ({ input, meta }) => {

            return (<>
                {OccupancyRate(maxseats, currentseats, 0, labels.busOccupancyRate, labels.almostFullWarning)}
                <div className="field">
                    <FloatLabel>
                        <Dropdown
                            disabled={!enabled}
                            {...input}
                            scrollHeight="300px"
                            options={enabled ? getBusLineData(values.busLine).stops.map(stop => stop.Title) : []}
                            placeholder={labels.boardingPoint}
                            className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                        />
                        <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                            {labels[label]}
                        </label>
                    </FloatLabel>
                    {getFormErrorMessage(meta)}
                </div>
            </>);
        }} />;
};
const TripTypeInput = ({ labels, isFormFieldValid, getFormErrorMessage, getBusLineData, getPrices, familyMember }) => {
    const { values } = useFormState();
    return <Field name={"tripType"} render={
        ({ input, meta }) => {
            return (
                <div className="field">
                    <ListBox
                        {...input}
                        disabled={!values['takesBus']}
                        options={[
                            {
                                'label':
                                    labels.oneway +
                                    (values['busLine'] ?
                                        " (" + getBusLineData(values['busLine']).currency + " " + getPrices(values['busLine'], familyMember.birthDate).PriceOneWay + ")" :
                                        ""),
                                'value': 'oneway'
                            },
                            {
                                'label': labels.return +
                                    (values['busLine'] ?
                                        " (" + getBusLineData(values['busLine']).currency + " " + getPrices(values['busLine'], familyMember.birthDate).PriceOneWay + ")" :
                                        ""),
                                'value': 'return'
                            },
                            {
                                'label': labels.roundtrip +
                                    (values['busLine'] ?
                                        " (" + getBusLineData(values['busLine']).currency + " " + getPrices(values['busLine'], familyMember.birthDate).PriceRoundTrip + ")" :
                                        ""),
                                'value': 'roundtrip'
                            }]}
                        placeholder={labels.tripType}
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    {getFormErrorMessage(meta)}
                </div>
            )
        }} />;
};
const Busline = (
    {
        familyMember,
        sfd,
        labels,
        busLines,
        labelslanguage,
        isFormFieldValid,
        getFormErrorMessage,
        getBusLineData,
        getPrices
    }
) => {
    return <Form onSubmit={(data, form) => {
        for (let key in data)
            familyMember[key] = data[key];
        if (!familyMember.takesBus) {
            delete familyMember.busLine;
            delete familyMember.tripType;
            delete familyMember.getAboardStop;
            delete familyMember.dropOffStop;
        }
        familyMember.currentStep++;
        sfd(familyMember);
    }}
        initialValues={
            familyMember
        }
        validate={(data) => {
            let error = {};
            let requiredFields = [];
            if (data['takesBus']) {
                requiredFields.push("busLine");
                requiredFields.push("tripType");
                if (['roundtrip', 'oneway'].includes(data['tripType']))
                    requiredFields.push("getAboardStop");
                if (['roundtrip', 'return'].includes(data['tripType']))
                    requiredFields.push("dropOffStop");

            }
            for (let f of requiredFields)
                if (!data[f])
                    error[f] = labels['This field is required.'];
            return error;
        }}
        render={({ handleSubmit }) => {
            return (<>
                <div className="grid ui-fluid">
                    <div className="col-12 md:col-6 flex flex-column justify-content-between">
                        <Field name={"takesBus"}
                            type="checkbox"
                            render={({ input, meta }) => (
                                <div className="takesbusfield field flex flex-row justify-content-between align-items-center">
                                    <label>{labels.takesBus}&nbsp;</label>
                                    <ToggleButton
                                        onLabel={labels.yes}
                                        offLabel={labels.no}
                                        onIcon="pi pi-check"
                                        offIcon="pi pi-times"
                                        {...input}
                                    />
                                </div>
                            )} />
                        <BuslineInput busLines={busLines} labels={labels} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} />
                    </div>
                    <div className="col-12 md:col-6">
                    <TripTypeInput labels={labels} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} getBusLineData={getBusLineData} getPrices={getPrices} familyMember={familyMember} />
                    </div>
                </div>
                <div className="grid ui-fluid">
                    <div className="col-12 md:col-6">
                        <BusStopPoint tripType="oneway" labels={labels} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} getBusLineData={getBusLineData} labelslanguage={labelslanguage} label="boardingPoint" inputname="getAboardStop" />
                    </div>
                    <div className="col-12 md:col-6">
                        <BusStopPoint tripType="return" labels={labels} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} getBusLineData={getBusLineData} labelslanguage={labelslanguage} label="dropOffPoint" inputname="dropOffStop" />
                    </div>
                </div>

                <div className="flex py-4 gap-2">
                    <Button
                        type="button"
                        label={labels.back}
                        severity="secondary"
                        icon="pi pi-arrow-left"
                        onClick={() => { familyMember.currentStep--; sfd(familyMember) }} />
                    <Button
                        type="button"
                        label={labels.next}
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        onClick={handleSubmit} />
                </div>
            </>)
        }} />;
}
export default Busline;